/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface RateConfigRule
 */
export interface RateConfigRule {
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRule
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'merchantCategoryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'merchantId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'binSponsor'?: RateConfigRuleBinSponsorEnum;
    /**
     * 
     * @type {string}
     * @memberof RateConfigRule
     */
    'creditOrPrepaid'?: RateConfigRuleCreditOrPrepaidEnum;
    /**
     * 
     * @type {number}
     * @memberof RateConfigRule
     */
    'minimumTotalAmount': number;
}

export const RateConfigRuleBinSponsorEnum = {
    lc: 'LC',
    cs: 'CS'
} as const;

export type RateConfigRuleBinSponsorEnum = typeof RateConfigRuleBinSponsorEnum[keyof typeof RateConfigRuleBinSponsorEnum];
export const RateConfigRuleCreditOrPrepaidEnum = {
    credit: 'CREDIT',
    prepaid: 'PREPAID'
} as const;

export type RateConfigRuleCreditOrPrepaidEnum = typeof RateConfigRuleCreditOrPrepaidEnum[keyof typeof RateConfigRuleCreditOrPrepaidEnum];


